import type { ApiClient } from './client';

export interface LoginResponse {
  userId: string;
  sessionJwt: string;
}

export function login(api: ApiClient, email: string, password: string): Promise<LoginResponse> {
  return api.request<LoginResponse>('POST', '/api/auth/login', { body: { email, password } });
}

export function logout(api: ApiClient): Promise<{ ok: true }> {
  return api.request<{ ok: true }>('POST', '/api/auth/logout');
}
